/**
 * MY — Declaration of Non-Beneficial Owner (Not a BO, M32110) Register Detail 매핑.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('M32110', {
  title: 'Declaration of Non-Beneficial Owner Details',
  fields: [
    { label: 'Company Name', key: ['entityName', 'companyName', 'company_name', 'presetForm.companyName', 'presetForm.state.values.company_name'] },
    { label: 'Registration No.', key: ['entityRegNo', 'companyRegistrationNo', 'presetForm.companyRegistrationNo', 'presetForm.state.values.company_registration_no'] },
    { label: 'Letter Date', key: ['presetForm.letterDate', 'presetForm.state.values.letter_date', 'letter_date'] },
    { label: 'Member Name', key: ['presetForm.memberName', 'presetForm.state.values.member_name', 'member_name'] },
    { label: 'Member Address', key: ['presetForm.state.values.member_address', 'member_address'] },
  ],
});
